var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as amplitude from '@amplitude/analytics-browser';
import { MemoryStorage } from '@amplitude/analytics-core';
// Disabled temporarily while we get Legal clearance
// import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { userAgentEnrichmentPlugin } from '@amplitude/plugin-user-agent-enrichment-browser';
import uuidv4 from 'uuid4';
import { DEFAULT_API_ENDPOINT } from './constant';
import { logInfoFactory, userIdSchema, initOptionsSchema, loginOptionsSchema, setUserGroupOptionsSchema, setUserPropertyOptionsSchema, setUserPropertiesOptionsSchema, incrementUserPropertyOptionsSchema, setUserGroupPropertyOptionsSchema, trackEventOptionsSchema, } from './util';
import { AmplitudeInitError, OptionsValidationError, EventNotTrackedError, UserPropertyNotSetError, UserPropertiesNotSetError, UserGroupPropertyNotSetError, NotInitialisedError, } from './error';
import { LogLevel, } from '@amplitude/analytics-types';
// Default options
var initDefaultOptions = {
    active: false,
    verbose: false,
    apiEndpoint: DEFAULT_API_ENDPOINT,
};
var amplitudeDefaultOptions = {
    storageProvider: new MemoryStorage(),
    identityStorage: 'none',
    serverZone: 'EU',
    autocapture: {
        pageViews: false,
    },
};
// Private
var provider = {
    amplitudeInstance: amplitude.createInstance(),
    appName: '',
    logInfo: logInfoFactory(false),
    isInitialised: false,
    isActive: false,
};
export function init(options) {
    return __awaiter(this, void 0, void 0, function () {
        var initOptions, validInitOptions, uaPlugin, amplitudeOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initOptions = __assign(__assign({}, initDefaultOptions), options);
                    return [4 /*yield*/, initOptionsSchema
                            .validate(initOptions)
                            .catch(function (err) { throw new AmplitudeInitError(err.message); })];
                case 1:
                    validInitOptions = _a.sent();
                    provider.appName = validInitOptions.appName;
                    provider.isActive = validInitOptions.active === true;
                    provider.logInfo = logInfoFactory(validInitOptions.verbose);
                    if (!provider.isActive) {
                        provider.logInfo('Initialised product analytics', validInitOptions);
                        return [2 /*return*/];
                    }
                    uaPlugin = userAgentEnrichmentPlugin({
                        deviceManufacturer: true,
                        deviceModel: true,
                        osVersion: true,
                        osName: true,
                    });
                    // Disabled temporarily while we get Legal clearance
                    // const sessionReplayTracking = sessionReplayPlugin({
                    //   debugMode: validInitOptions.verbose,
                    //   sampleRate: 1,
                    // });
                    provider.amplitudeInstance.add(uaPlugin);
                    amplitudeOptions = __assign(__assign({}, amplitudeDefaultOptions), { instanceName: "".concat(validInitOptions.appName, "_").concat(uuidv4()), appVersion: validInitOptions.appVersion, serverUrl: validInitOptions.apiEndpoint, logLevel: validInitOptions.verbose ? LogLevel.Verbose : LogLevel.Error });
                    return [2 /*return*/, provider.amplitudeInstance
                            .init(validInitOptions.apiKey, null, amplitudeOptions).promise
                            .then(function (result) {
                            provider.isInitialised = true;
                            return result;
                        })
                            .catch(function (error) {
                            throw new AmplitudeInitError(error.message);
                        })];
            }
        });
    });
}
// User session
export function login(options) {
    return __awaiter(this, void 0, void 0, function () {
        var validLoginOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loginOptionsSchema
                        .validate(options)
                        .catch(function (err) { throw new OptionsValidationError(err.message); })];
                case 1:
                    validLoginOptions = _a.sent();
                    if (!provider.isActive) {
                        provider.logInfo('Logged in user', validLoginOptions);
                        return [2 /*return*/];
                    }
                    if (!provider.isInitialised) {
                        throw new NotInitialisedError('login');
                    }
                    return [2 /*return*/, Promise.all([
                            provider.amplitudeInstance.setUserId(validLoginOptions.userId),
                            provider.amplitudeInstance.setGroup('mandant', validLoginOptions.mandantId).promise,
                            provider.amplitudeInstance.setGroup('customer', validLoginOptions.customerId).promise,
                        ])];
            }
        });
    });
}
export function logout() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!provider.isInitialised) {
                throw new NotInitialisedError('logout');
            }
            if (!provider.isActive) {
                provider.logInfo('Logged out user');
                return [2 /*return*/];
            }
            return [2 /*return*/, Promise.all([
                    provider.amplitudeInstance.setUserId(null),
                    provider.amplitudeInstance.flush().promise,
                ])];
        });
    });
}
// User properties
export function setUserId(userId) {
    return __awaiter(this, void 0, void 0, function () {
        var validUserId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userIdSchema
                        .validate(userId)
                        .catch(function (err) { throw new OptionsValidationError(err.message); })];
                case 1:
                    validUserId = _a.sent();
                    if (!provider.isActive) {
                        provider.logInfo('Set user id', validUserId);
                        return [2 /*return*/];
                    }
                    if (!provider.isInitialised) {
                        throw new NotInitialisedError('setUserId');
                    }
                    return [2 /*return*/, provider.amplitudeInstance.setUserId(validUserId)];
            }
        });
    });
}
export function setUserGroup(userGroupType, userGroupName) {
    return __awaiter(this, void 0, void 0, function () {
        var validSetUserGroupOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setUserGroupOptionsSchema
                        .validate({ userGroupType: userGroupType, userGroupName: userGroupName }, { stripUnknown: true })
                        .catch(function (err) { throw new OptionsValidationError(err.message); })];
                case 1:
                    validSetUserGroupOptions = _a.sent();
                    if (!provider.isActive) {
                        provider.logInfo('Set user group', validSetUserGroupOptions);
                        return [2 /*return*/];
                    }
                    if (!provider.isInitialised) {
                        throw new NotInitialisedError('setUserGroup');
                    }
                    return [2 /*return*/, provider.amplitudeInstance.setGroup(validSetUserGroupOptions.userGroupType, validSetUserGroupOptions.userGroupName)];
            }
        });
    });
}
export function setUserProperty(key, value) {
    return __awaiter(this, void 0, void 0, function () {
        var validSetUserPropertyOptions, identifyEvent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setUserPropertyOptionsSchema
                        .validate({ key: key, value: value })
                        .catch(function (err) { throw new OptionsValidationError(err.message); })];
                case 1:
                    validSetUserPropertyOptions = _a.sent();
                    if (!provider.isActive) {
                        provider.logInfo('Set user property', validSetUserPropertyOptions);
                        return [2 /*return*/];
                    }
                    if (!provider.isInitialised) {
                        throw new NotInitialisedError('setUserProperty');
                    }
                    identifyEvent = (new amplitude.Identify())
                        .set(validSetUserPropertyOptions.key, validSetUserPropertyOptions.value);
                    return [2 /*return*/, provider.amplitudeInstance
                            .identify(identifyEvent)
                            .promise
                            .catch(function (reason) {
                            throw new UserPropertyNotSetError(key, reason.statusCode, reason.message);
                        })];
            }
        });
    });
}
export function setUserProperties(userProperties) {
    return __awaiter(this, void 0, void 0, function () {
        var validSetUserPropertiesOptions, identifyEvent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setUserPropertiesOptionsSchema
                        .validate({ userProperties: userProperties })
                        .catch(function (err) { throw new OptionsValidationError(err.message); })];
                case 1:
                    validSetUserPropertiesOptions = _a.sent();
                    if (!provider.isActive) {
                        provider.logInfo('Set user properties', validSetUserPropertiesOptions);
                        return [2 /*return*/];
                    }
                    if (!provider.isInitialised) {
                        throw new NotInitialisedError('setUserProperties');
                    }
                    identifyEvent = Object.keys(validSetUserPropertiesOptions.userProperties)
                        .reduce(function (idEvent, key) { return idEvent.set(key, validSetUserPropertiesOptions.userProperties[key]); }, new amplitude.Identify());
                    return [2 /*return*/, provider.amplitudeInstance.identify(identifyEvent).promise.catch(function (reason) {
                            throw new UserPropertiesNotSetError(validSetUserPropertiesOptions.userProperties, reason.statusCode, reason.message);
                        })];
            }
        });
    });
}
export function setUserGroupProperty(groupType, groupName, key, value) {
    return __awaiter(this, void 0, void 0, function () {
        var validSetUserGroupPropertyOptions, identifyEvent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setUserGroupPropertyOptionsSchema
                        .validate({ groupType: groupType, groupName: groupName, key: key, value: value })
                        .catch(function (err) { throw new OptionsValidationError(err.message); })];
                case 1:
                    validSetUserGroupPropertyOptions = _a.sent();
                    if (!provider.isActive) {
                        provider.logInfo('Set user group property', validSetUserGroupPropertyOptions);
                        return [2 /*return*/];
                    }
                    if (!provider.isInitialised) {
                        throw new NotInitialisedError('setUserGroupProperty');
                    }
                    identifyEvent = (new amplitude.Identify())
                        .set(validSetUserGroupPropertyOptions.key, validSetUserGroupPropertyOptions.value);
                    return [2 /*return*/, provider.amplitudeInstance
                            .groupIdentify(validSetUserGroupPropertyOptions.groupType, validSetUserGroupPropertyOptions.groupName, identifyEvent)
                            .promise
                            .catch(function (reason) {
                            throw new UserGroupPropertyNotSetError(key, reason.statusCode, reason.message);
                        })];
            }
        });
    });
}
export function incrementUserProperty(key, incrementBy) {
    return __awaiter(this, void 0, void 0, function () {
        var validIncrementUserPropertyOptions, identifyEvent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, incrementUserPropertyOptionsSchema
                        .validate({ key: key, incrementBy: incrementBy })
                        .catch(function (err) { throw new OptionsValidationError(err.message); })];
                case 1:
                    validIncrementUserPropertyOptions = _a.sent();
                    if (!provider.isActive) {
                        provider.logInfo('Incremented user property', validIncrementUserPropertyOptions);
                        return [2 /*return*/];
                    }
                    if (!provider.isInitialised) {
                        throw new NotInitialisedError('incrementUserProperty');
                    }
                    identifyEvent = (new amplitude.Identify())
                        .add(validIncrementUserPropertyOptions.key, validIncrementUserPropertyOptions.incrementBy);
                    return [2 /*return*/, provider.amplitudeInstance
                            .identify(identifyEvent)
                            .promise
                            .catch(function (reason) {
                            throw new UserPropertyNotSetError(key, reason.statusCode, reason.message);
                        })];
            }
        });
    });
}
export function trackEvent(eventName_1) {
    return __awaiter(this, arguments, void 0, function (eventName, eventProperties) {
        var validTrackEventOptions, eventPropertiesWithInstanceName;
        if (eventProperties === void 0) { eventProperties = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, trackEventOptionsSchema
                        .validate({ eventName: eventName, eventProperties: eventProperties })
                        .catch(function (err) { throw new OptionsValidationError(err.message); })];
                case 1:
                    validTrackEventOptions = _a.sent();
                    if (!provider.isActive) {
                        provider.logInfo('Tracked event', validTrackEventOptions);
                        return [2 /*return*/];
                    }
                    if (!provider.isInitialised) {
                        throw new NotInitialisedError('trackEvent');
                    }
                    eventPropertiesWithInstanceName = __assign(__assign({}, validTrackEventOptions.eventProperties), { appName: provider.appName });
                    return [2 /*return*/, provider.amplitudeInstance.track(validTrackEventOptions.eventName, eventPropertiesWithInstanceName).promise.catch(function (reason) {
                            throw new EventNotTrackedError(eventName, reason.statusCode, reason.message);
                        })];
            }
        });
    });
}
//# sourceMappingURL=provider.js.map